// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useFilterablePaginatedSectionQuery } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Fetching/useFilterablePaginatedSectionQuery";
import { useBrowseLayoutQuery } from "@faire/retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/DataFetching/v3/useBrowseLayoutQuery";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import { ViewLayoutPlacement } from "@faire/web-api--source/indigofair/data/ViewLayoutPlacement";
import first from "lodash/first";

// This hook gives us info about the exact FPS that the layout API has told us to
// fetch on the page. We need this because the FPS request we prefetch blindly may
// not match the FPS request details that the layout API tells us to fetch with.
export const useBrowseLayoutDefinedFilteredComponentsQuery = () => {
  const { data: layoutData, isFetching: isLayoutFetching } =
    useBrowseLayoutQuery(ViewLayoutPlacement.FPS);

  const fpsRequestInfoFromV3Layout = first(
    layoutData?.content
      .map((section) => section.filterable_paginated_section)
      .filter(isNotUndefined)
  );

  // get the FPS request info that the layout API told us to fetch
  const fpsRequest =
    fpsRequestInfoFromV3Layout ?? IFilterablePaginatedSection.build();

  const fpsRequestInfo = fpsRequest.get_s_d_u_i_filtered_components;

  // disable this query if the layout is fetching or if there is no
  // FPS request info in the layout
  const disableQuery = fpsRequestInfo === undefined || isLayoutFetching;

  // if the correct filtered-components request was made during prefetching,
  // this will reference the same query
  const {
    filteredComponentsData,
    filteredComponentsDataUpdatedAt,
    isFilteredComponentsFetching,
    isFilteredComponentsError,
  } = useFilterablePaginatedSectionQuery(fpsRequest, disableQuery);

  return {
    data: filteredComponentsData,
    isError: isFilteredComponentsError,
    isFetching: isFilteredComponentsFetching,
    dataUpdatedAt: filteredComponentsDataUpdatedAt,
  };
};
